var scope_0 = require('/Users/mhartington/Github/builders-deep-dive/slides/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b64cc088e0cb0dc9a5410402ffb9b77.js').default;export default
        Object.assign({}, scope_0 )
    